import React from "react";
import styled from "styled-components";

const Container = styled.div`
  margin-top: 1rem;
`;

const Header = styled.div`
  background: ${props => props.theme.colors.fog};
  border-radius: 4px;
  color: inherit;
  padding: 0.5rem;
  font-size: 1rem;
  font-weight: bold;
`;

const Body = styled.div`
  padding: 0.5rem;
`;

type BullseyeSubSectionProps = {
  header: string;
  children?: React.ReactNode;
};

const BullseyeSubSection: React.FC<BullseyeSubSectionProps> = ({ header, children }) => {
  return (
    <Container>
      <Header>{header}</Header>
      <Body>{children}</Body>
    </Container>
  );
};

export default BullseyeSubSection;
